import { graphql } from "@/lib/gql/__generated__";

export const SnackCreate_SnackPage_Mutation = graphql(`
	mutation SnackCreate_SnackPage($input: SnackInput!) {
		snackCreate(input: $input) {
			userErrors
			snack {
				id
				uuid
				snackType
				hotelID
				ownerType
				isPublished
				isParentTemplate
				slug
				title
				description
				thumbnail
				snack {
					bucket
					key
					region
					mimeType
					fileName
				}
				availablePlansForHotel
				createdAt
				updatedAt
			}
		}
	}
`);
